/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
 */

export const SUPPORTED_TYPE: any = [
    'pdf',
    'doc',
    'docx',
    'xls',
    'xlsx',
    'jpg',
    'png',
    'ppt',
    'pptx'
];
